<template>
	<div id="clubClass_left3">
		<div class="cc-header">课程分布</div>
		<div class="main-value" id="course_ditri"></div>
	</div>
</template>

<script>
var storage = window.localStorage;
var orgId = storage.getItem("orgId");
const echarts = require("echarts");
let pageSize = 9; //echarts每页显示数量
let gradeCourseNumInfoChart;
export default {
	data() {
		return {
			start: 0,
			end: pageSize - 1,
			total: 0
		};
	},
	mounted() {
		this.initData();
		// 定时器刷新，30分钟
		let _this = this;
		this.interval1 = setInterval(() => {
			_this.initData();
		}, 1000 * 60 * 30);
		// 定时器轮播，5秒
		this.interval2 = setInterval(() => {
			_this.dataZoomAutoScoll();
		}, 1000 * 5);
	},
	methods: {
		//echarts图标数据过多时，x轴自动滑动
		dataZoomAutoScoll() {
			const max = this.total - 1;
			if (pageSize < this.total) {
				if (this.end > max || this.start > max - pageSize) {
					this.start = 0;
					this.end = pageSize - 1;
				} else {
					this.start += 1;
					this.end += 1;
				}
				gradeCourseNumInfoChart.dispatchAction({
					type: 'dataZoom',
					dataZoomIndex: 0,
					startValue: this.start,
					endValue: this.end
				});
			}
		},
		initData() {
			let _this = this;
			// 基于准备好的dom，初始化echarts实例
			gradeCourseNumInfoChart = echarts.init(
				document.getElementById("course_ditri")
			);
			this.$http.get("/dataView/clubClass/getGradeCourseNumInfo?orgId=" + orgId).then(res => {
				if (res.data.code === 200) {
					_this.total = res.data.result.length;
					var xData = [];
					var yData = [];
					for (var i = 0; i < res.data.result.length; i++) {
						var obj = res.data.result[i];
						xData.push(obj.gradeName);
						yData.push(obj.courseNum);
					}
					var option = {
						tooltip: {
							trigger: 'axis',
							formatter: function (params) {
								var relVal = params[0].name;
								for (var i = 0; i < params.length; i++) {
									relVal += '<br/>' + params[i].marker + '&nbsp;' + params[i].seriesName + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>' + params[i].value + '</b>';
								}
								return relVal
							}
						},
						dataZoom: [{
							type: 'inside',
							startValue: _this.start,
							endValue: _this.end,
						}],
						xAxis: [{
							type: 'category',
							scale: true,
							data: xData,
							boundaryGap: true,
							axisLabel: {
								interval: 0,
								rotate: 30, // 角度
								formatter: function (value) {
									return (value.length > 6 ? (value.slice(0, 6) + "...") :
										value)
								},
								textStyle: {
									color: '#34deff',
									fontSize: fontSize(0.12)
								}
							}
						}],
						grid: {
							left: "10%",
							top: "5%",
							bottom: "20%",
						},
						yAxis: [{
							type: 'value',
							splitLine: {
								show: true,
								lineStyle: {
									width: 1,
									color: 'rgba(255, 255, 255, 0.2)',
								}
							},
							axisLabel: {
								textStyle: {
									color: '#34deff',
									fontSize: fontSize(0.12)
								}
							},
							axisLine: {
								show: true
							},
						}],
						series: [{
							name: '课程数',
							type: 'bar',
							data: yData,
							itemStyle: {
								//柱形图圆角，鼠标移上去效果，如果只是一个数字则说明四个参数全部设置为那么多
								normal: {
									//柱形图圆角，初始化效果
									barBorderRadius: [50],
									color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
										offset: 0,
										color: "rgb(255, 189, 56,0.8)" // 0% 处的颜色
									}, {
										offset: 1,
										color: "rgb(255, 243, 74,0.6)" // 100% 处的颜色
									}], false)
								}
							},
							barGap: '0%',
							barWidth: 12
						}]
					};
					gradeCourseNumInfoChart.hideLoading(); //没有加载出来隐藏加载动画
					gradeCourseNumInfoChart.setOption(option);
					// 响应式变化
					window.addEventListener("resize", () => gradeCourseNumInfoChart.resize(), false);
				}
			});
		}
	},
	beforeDestroy() {
		clearInterval(this.interval1);
		clearInterval(this.interval2);
	},
	destroyed() {
		window.onresize = null;
	}
};

function fontSize(res) {
	let clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	if (!clientWidth) return;
	let fontSize = 100 * (clientWidth / 1920);
	return res * fontSize;
}
</script>

<style lang="scss">
#clubClass_left3 {
	height: 100%;

	.cc-header {
		width: 100%;
		text-align: center;
		background: url("../../assets/img/ac_titbgsmall.png") center no-repeat;
		background-size: 100%;
		color: #0ef3ff;
		font-size: 0.22rem;
		font-weight: bold;
		height: 0.8rem;
		line-height: 0.6rem;
	}

	.main-value {
		height: 75%;
		padding-left: 3%;
	}

}
</style>